import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
// Fix for default marker icon in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});
export function Location() {
  const {
    t
  } = useLanguage();
  const position: [number, number] = [34.0622, -118.3634]; // Wilshire Blvd, Beverly Hills area
  return <section className="py-20 lg:py-28 bg-white" data-id="element-213" data-mp="3oif3sdn34wj6">
      <div className="container mx-auto px-6" data-id="element-214" data-mp="78qkgxf3u6pn">
        <div className="grid lg:grid-cols-12 gap-16 lg:gap-24 items-center max-w-6xl mx-auto" data-id="element-215" data-mp="77fgoxlnsyyj">
          <div className="lg:col-span-4" data-id="element-216" data-mp="2c9vk102zobi">
            <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-217" data-mp="3jbq27uuk11th">
              {t('location.eyebrow')}
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-light text-brand-dark mb-12 tracking-tight" data-id="element-218" data-mp="3ocdu0iqlxmor">
              {t('location.heading')}
            </h2>

            <div className="space-y-10" data-id="element-219" data-mp="16czq1h7rgdc">
              <div data-id="element-220" data-mp="137e4w7smwmd">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-221" data-mp="64wriiihnmdm">
                  {t('location.addressLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80 leading-relaxed" data-id="element-222" data-mp="b1erz66scyk5">
                  6404 Wilshire Blvd
                  <br data-id="element-223" data-mp="jwkzqapm9qpb" />
                  Suite 610
                  <br data-id="element-224" data-mp="jv9vyaw68iy7" />
                  Los Angeles, CA 90048
                </p>
              </div>

              <div data-id="element-225" data-mp="owz8juz1l4oe">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-226" data-mp="otbhd2h2kucu">
                  {t('location.phoneLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80" data-id="element-227" data-mp="2pxne8aiunxqd">
                  <a href="tel:+17026604534" className="hover:text-brand-dark transition-colors" data-id="element-228" data-mp="2kzc21t531b4z">
                    (702) 660-4534
                  </a>
                </p>
              </div>

              <div data-id="element-229" data-mp="2uunm8qz9fak4">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-230" data-mp="38nc4hqbrapze">
                  {t('location.hoursLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80 leading-relaxed" data-id="element-231" data-mp="34omgl3t3dq1i">
                  {t('location.hours')}
                </p>
              </div>

              <div className="pt-4" data-id="element-232" data-mp="3dnhpinnite8i">
                <button onClick={() => document.getElementById('contacto')?.scrollIntoView({
                behavior: 'smooth'
              })} className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/70 hover:text-brand-dark transition-colors inline-flex items-center gap-2 border-b border-brand-gold/40 pb-1" data-id="element-233" data-mp="1o80e67m7qb2w">
                  {t('nav.cta')} →
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 h-[500px] lg:h-[600px] w-full rounded-[2rem] overflow-hidden border border-brand-stone/50 z-0" data-id="element-234" data-mp="3q499sctlu287">
            <MapContainer center={position} zoom={13} scrollWheelZoom={false} className="w-full h-full" data-id="element-235" data-mp="3c85jguluqe10">
              <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" data-id="element-236" data-mp="32969n8pcoccf" />
              <Marker position={position} data-id="element-237" data-mp="15fv0o55wpy99">
                <Popup data-id="element-238" data-mp="15etdj2bm9lb6">
                  Lipo Laser · Beverly Hills <br data-id="element-239" data-mp="31izq5f9gi4gn" /> {t('location.address')}
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </div>
    </section>;
}